/* eslint-disable no-console */
import $ from 'jquery'
import 'slick-carousel'
import 'jquery-match-height'

$(() => {
  $('.main-image .images').slick({
    dots: true
  })

  $('.main-container .article-block .content').matchHeight()

  const $pagetop = $('.pagetop-button')
  $pagetop.hide()
  $(window).on('scroll', () => {
    if ($(window).scrollTop() > 100) {
      $pagetop.fadeIn()
    } else {
      $pagetop.fadeOut()
    }
  })

  $pagetop.on('click', (e) => {
    e.preventDefault
    $('body, html').animate({scrollTop: 0}, 500)
  })

  const $mobileMenu = $('.header-mobile .menu a')
  $mobileMenu.on('click', (e) => {
    e.preventDefault
    $('.global-nav').toggleClass('-show')
  })
})



// WEBPACK FOOTER //
// ./src/js/main.js